import * as d3 from 'd3'
import React from 'react'

const D3Wrapper = ({ width, height, x, y, render, data }) => {
  const refAnchor = React.useRef(null)
  const [redrawFunction, setRedrawFunction] = React.useState(null)

  React.useEffect(() => {
    // draw the initialization once
    if (!redrawFunction && data) {
      const fn = render(d3.select(refAnchor.current), data)
      setRedrawFunction({ fn })
    }
  }, [redrawFunction, data, render])

  // update on data changes
  React.useEffect(() => {
    if (redrawFunction && data) {
      redrawFunction.fn(data)
    }
  }, [data, redrawFunction])

  const rendered = React.useMemo(
    () => (
      <svg width={width} height={height}>
        <g ref={refAnchor} transform={`translate(${x || 0}, ${y || 0})`} />
      </svg>
    ),
    [width, height, x, y]
  )

  return rendered
}

export default React.memo(D3Wrapper)
